
// SVG Icon: help-thick
export default { id: "terriajs-help-thick" };
export const id = "terriajs-help-thick";
export const name = "help-thick";
